import { render, staticRenderFns } from "./AlarmModule.vue?vue&type=template&id=3c32c8d6&scoped=true"
import script from "./AlarmModule.vue?vue&type=script&lang=js"
export * from "./AlarmModule.vue?vue&type=script&lang=js"
import style0 from "./AlarmModule.vue?vue&type=style&index=0&id=3c32c8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c32c8d6",
  null
  
)

export default component.exports